package com.kinoshazam.uiKit.components.menuItem

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.animations.scaleAnimation
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.components.toDrawableResource
import com.kinoshazam.uiKit.extension.thenIf
import com.kinoshazam.uiKit.theme.Large
import com.kinoshazam.uiKit.theme.UiKitTheme
import com.kinoshazam.uiKit.theme.middleRadius
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.painterResource

@OptIn(ExperimentalResourceApi::class, InternalResourceApi::class)
@Composable
fun MenuItem(
    state: MenuItemState,
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = modifier
            .fillMaxWidth()
            .height(44.dp)
            .clip(shape = middleRadius)
            .clickable {
                state.onAction()
            }
            .background(color = if (state.isSelected) UiKitTheme.colors.color_1 else Color.Transparent)
            .padding(horizontal = 7.dp)

    ) {
        state.iconRes?.let { iconRes ->
            Image(
                painter = painterResource(iconRes.toDrawableResource()),
                contentScale = ContentScale.Fit,
                contentDescription = null,
                modifier = Modifier.size(24.dp)
                    .thenIf(Modifier.scale(scaleAnimation()), state.animateIcon),
                colorFilter = ColorFilter.tint(
                    color = state.tintColor
                        ?: if (state.isSelected) UiKitTheme.colors.color_7 else UiKitTheme.colors.color_6
                )
            )
        }

        TextLabel(
            modifier = Modifier.padding(start = state.gap),
            state = TextLabelState(
                text = state.title.orEmpty(),
                color = if (state.isSelected) UiKitTheme.colors.color_7 else UiKitTheme.colors.color_2,
                textStyle = Large,
                maxLines = 1,
            ),
        )

//        Text(
//            text = state.title,
//            style = Large,
//            color = if (state.isSelected) UiKitTheme.colors.color_7 else UiKitTheme.colors.color_2,
//            modifier = Modifier.padding(start = 26.dp),
//            maxLines = 1,
//        )
    }

}